export default __webpack_public_path__ + "static/media/system_01_07.4f84be96.jpg";